<template>
    <div align="center">
        <el-dialog title="提示" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
            <span>{{ msg }}</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
        <div v-if="bPrompt">
            <el-form :inline="true">
                <el-form-item label="请输入昵称：">
                    <el-input v-model="nickname" placeholder="Enter your nickname"></el-input>
                </el-form-item>
                <el-button type="primary" @click="bPrompt = false; getRoomsInfo()">确 定</el-button>
            </el-form>

        </div>
        <div align="center" v-else>
            <table class="notice" :style="{ width: tableWidth, height: tableHeight }">
                <tr v-for="(a, i) in datas" v-bind:key="i">
                    <td v-for="(b, j) in a" v-bind:key="j" @click="click(b)" :id="b"
                        v-bind:style="{ background: bgcolors[b] }">
                        <span :style="{ 'font-size': fontSize }">{{ b }}</span>
                    </td>
                </tr>
            </table>
            <br>
            <table style="width:80%; text-align:center">
                <tr>
                    <td width="20%">
                        <span>请点击：{{ calcTip }}</span>
                    </td>
                    <td width="20%">
                        <span>时间：{{ usedtime }}</span>
                    </td>
                    <td width="30%">
                        <el-button @click="startGame()">开始对战</el-button>
                    </td>
                    <td width="30%">
                        <el-button @click="Refresh">单人开始</el-button>
                    </td>
                </tr>
            </table>
            <div style="width: 80%; align: left">
                <table style="width:80%; text-align:center">
                    <tr><td colspan =4>Room:{{ this.roomInfo.roomName }} Name:{{ this.nickname }}</td></tr>
                    <tr>
                        <th width="20%">玩家</th>
                        <th width="10%">时间</th>
                        <th width="20%">状态</th>
                        <th width="50%">进度</th>
                    </tr>
                    <tr v-for="(player,index) in roomInfo.players" :key="player.nickname">
                        <td>{{ player.nickname }}</td>
                        <td>{{ uTime[index] }}</td>
                        <td>{{ player.status }}</td>
                        <td>
                            <el-progress :percentage="player.progress" :color="customColors"></el-progress>
                        </td>
                    </tr>
                </table>
                <br>
            </div>
            <div id="roomsInfo" class="rooms-info-container">
                <div v-for="room in rooms" :key="room.roomName" style="margin-bottom: 10px;">
                    <el-badge :value="room.playerCount" class="item" :type="getBadgeType(room.playerCount)">
                        <el-button @click="handleRoomButtonClick(room)">
                            {{ room.roomName }}
                        </el-button>
                    </el-badge>
                    <!-- <span v-if="room.playerCount >= 2" style="color: red; margin-left: 10px;">房间已满</span> -->
                </div>
                <div>
                    <el-button @click="leaveRoom()">离开房间</el-button>
                </div>
            </div>

            <div>
                <el-form :inline="true">
                    <el-form-item label="房间名：">
                        <el-input v-model="roomName" placeholder="Enter room name"></el-input>
                    </el-form-item>
                    <el-button @click="createRoom()">创建房间</el-button>
                    <el-button @click="getRoomsInfo()">获取信息</el-button>
                </el-form>

            </div>

        </div>

    </div>
</template>

<script>
function sleep(time) {
    return new Promise(resolve =>
        setTimeout(resolve, time)
    )
}



import conf from "../config"

// const WebSocket = require('ws');


export default {
    name: "noticePractise",
    data() {
        return {
            "baseurl": conf.dataServer,
            "row": 5,
            "col": 5,
            datas: [],
            timer: null,
            starttime: 0,
            usedtime: 0.00,
            uTime: [0, 0],
            bPrompt: true,
            bFinish: false,
            cur: 0,
            bgcolors: [],
            okcolor: "chartreuse",
            wrongcolor: "coral",
            defaultcolor: "#42b983",
            customColors: [
                { color: '#f56c6c', percentage: 20 },
                { color: '#e6a23c', percentage: 40 },
                { color: '#5cb87a', percentage: 60 },
                { color: '#1989fa', percentage: 80 },
                { color: '#6f7ad3', percentage: 100 }
            ],
            percentage: 0,
            dialogVisible: false,
            msg: "成功完成。耗时：",
            tableWidth: '80%',
            tableHeight: "50%",
            fontSize: '',
            name: '',
            noResize: false,
            ws: {},
            roomInfo: {},
            rooms: [],
            nickname: '',
            roomName: '',

        }
    },
    mounted() {
        this.initTable();
        // const currentUrl = window.location.href;
        // const url = new URL(currentUrl);

        // 构建 WebSocket URL
        const websocketUrl = this.baseurl; // 假设 WebSocket 服务器的端口是 8080
        this.ws = new WebSocket(websocketUrl);
        this.ws.onmessage = (event) => {
            const data = JSON.parse(event.data);
            // const roomInfo = document.getElementById('roomInfo');
            switch (data.type) {
                case 'roomCreated':
                    // roomInfo.innerHTML = `Room created: ${data.roomName}`;
                    this.msg = `Room created: ${data.roomName}`;
                    this.$message.success(this.msg);
                    break;
                case 'roomJoined':
                    // roomInfo.innerHTML = `Joined room: ${data.roomName}`;
                    this.msg = `Joined room: ${data.roomName}`;
                    this.$message.success(this.msg)
                    break;
                case 'roomFull':
                    // roomInfo.innerHTML = 'Room is full';
                    this.msg = 'Room is full';
                    this.$message.warn(this.msg);
                    break;
                case 'roomState':
                    // roomInfo.innerHTML = `Players in room: ${data.players.join(', ')}`;
                    this.roomInfo = data.roomState;
                    // console.log(this.roomInfo);

                    break;
                case 'gameStarted':
                    // console.log('gameStarted',JSON.stringify(data));
                    this.msg = 'Game started';
                    this.$message.success(this.msg);
                    this.datas = data.layout;

                    this.starttime = Date.now();
                    this.cur = 0;
                    this.percentage = 0;
                    this.usedtime = 0;
                    this.uTime = [0,0];
                    if (this.timer) {
                        clearInterval(this.timer);
                    }
                    this.timer = setInterval(() => {
                        this.usedtime = ((Date.now() - this.starttime) / 1000).toFixed(2);
                    }, 100)
                    break;
                case 'gameStartFailed':
                    // roomInfo.innerHTML = `Game start failed: ${data.message}`;
                    this.$message.error(`Game start failed: ${data.message}`)
                    break;
                case 'gameStartPending':
                    // roomInfo.innerHTML = `Game start pending: ${data.message}`;
                    this.$message.warn(`Game start pending: ${data.message}`);
                    break;
                case 'roomsInfo':
                    // this.displayRoomsInfo(data.roomsInfo);

                    this.rooms = data.roomsInfo;
                    console.log('roomsInfo', JSON.stringify(this.rooms))
                    break;
                case 'gameOver':
                    // roomInfo.innerHTML = `Game over: ${data.message}`;
                    // this.$message.info(`Game over: ${data.message}。用时：${this.usedtime}秒`);
                    if (this.timer) {
                        clearInterval(this.timer);
                    }
                    this.timer = null;
                    {
                        const index = this.roomInfo.players.findIndex(player => player.status === "lose" || player.status === "finish");
                        this.uTime[index] = this.usedtime;
                    }
                    this.bFinish = true;
                    break;
                case 'gameWin':
                    // roomInfo.innerHTML = `Game over: ${data.message}`;
                    this.$message.success(`Game Win: ${data.message}。`);
                    {
                        const index = this.roomInfo.players.findIndex(player => player.nickname === data.winer);
                        this.uTime[index] = this.usedtime;
                    }


                    break;
                case 'gameLose':
                    // roomInfo.innerHTML = `Game over: ${data.message}`;
                    this.$message.error(`Game Lose: ${data.message}。`);
                    {
                        const index = this.roomInfo.players.findIndex(player => player.nickname === data.winer);
                        this.uTime[index] = this.usedtime;
                    }

                    break;
                default:
                    break;
            }
        };
        this.caculateSize();
        window.onresize = () => {
            this.caculateSize();
        }
        // this.getRoomsInfo()
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
    methods: {
        initTable() {
            let i = 0;
            let j = 0;
            this.datas = new Array(this.row);
            if (this.row * this.col > 100) {
                this.msg = "目前数字限制在100以内。"
                this.dialogVisible = true;
            } else {
                for (i = 0; i < this.row; i++) {
                    this.datas[i] = new Array(this.col);
                    for (j = 0; j < this.col; j++) {
                        this.datas[i][j] = 0;
                    }
                }
                this.bgcolors = [];
                for (i = 0; i <= this.row * this.col; i++) {
                    this.bgcolors.push(this.defaultcolor);
                }
                this.caculateSize();
            }

            /*                for(i=0; i< this.datas.length; i++) {
                                this.datas.pop();
                            }
                            for(i=0; i< this.bgcolors.length; i++) {
                                this.bgcolors.pop();
                            }
                            for(i=0;i<this.row; i++){
                                let a =[];
                                for(j=0;j<this.col;j++){
                                    a.push(0);
                                }
                                this.datas.push(a);
                            }
                            for(i=0; i<= this.row * this.col; i++){
                                this.bgcolors.push(this.defaultcolor);
                            }*/
            //改变行大小，需要重新计算表格大小。

        },
        Refresh() {
            /*
            fetch(this.baseurl + "?row=" + this.row + "&col=" + this.col)
                .then(res=>res.json())
                .then(bs => {
                    this.datas = bs;
                    this.row = this.datas.length;
                    if(this.row>0) this.col = this.datas[0].length;
                    //window.console.log("row:%d, col:%d", this.row, this.col);
                    //window.console.log(this.datas);
                })
                */
            this.roomInfo.roomName = 'practiseRoom';
            const player = { nickname: this.nickname, status: 'start', progress: 0 };
            this.roomInfo.players = [player];

            const numbers = Array.from({ length: this.row * this.col }, (_, i) => i + 1);
            for (let i = numbers.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [numbers[i], numbers[j]] = [numbers[j], numbers[i]];
            }
            const layout = [];
            for (let i = 0; i < 5; i++) {
                layout.push(numbers.slice(i * 5, (i + 1) * 5));
            }
            this.datas = layout;

            //this.bgcolors[this.row * this.col]=this.defaultcolor;

            this.starttime = Date.now();
            this.cur = 0;
            this.percentage = 0;
            this.usedtime = 0;
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.usedtime = ((Date.now() - this.starttime) / 1000).toFixed(2);
            }, 100)
        },

        customColorMethod(percentage) {
            if (percentage < 30) {
                return '#909399';
            } else if (percentage < 70) {
                return '#e6a23c';
            } else {
                return '#67c23a';
            }
        },
        click(b) {
            if (b == this.cur + 1) {
                this.bgcolors[b] = this.okcolor;
                // this.bgcolors[b] = this.wrongcolor;
                this.bgcolors[this.cur] = this.defaultcolor

                this.cur++;
                this.percentage = Math.round(this.cur * 100 / (this.row * this.col));
                if (b == this.col * this.row) {
                    // clearInterval(this.timer);

                    this.msg = "成功完成。耗时：" + this.usedtime + "秒。";
                    // this.dialogVisible = true;
                    this.bgcolors[b] = this.defaultcolor;
                }
                //更新游戏房间信息roomInfo
                if (this.roomInfo.roomName) {
                    const player = this.roomInfo.players.find(p => p.nickname === this.nickname);
                    if (player) {
                        player.progress = this.percentage;

                    }
                    if (this.roomInfo.roomName === "practiseRoom") {
                        if (this.percentage === 100) {
                            player.status = 'finish';
                            this.bFinish = true;
                            this.uTime[0] = this.usedtime;
                            clearInterval(this.timer);
                            this.timer = null;
                        }


                    } else if (player.status === 'start' || player.status === 'lose') {
                        let roomState = {
                            "roomName": this.roomInfo.roomName,
                            "nickname": player.nickname,
                            "status": player.status,
                            "progress": player.progress
                        }
                        this.updateGameProgress(roomState)
                    }

                } 

            } else {
                // this.bgcolors[b] = this.wrongcolor;
                this.$set(this.bgcolors, b, this.wrongcolor);
                console.log("wrong", this.wrongcolor);
                // this.starttime -= 3 * 1000;
                sleep(1000).then(() => {
                    console.log("sleep", b)
                    // this.bgcolors[b] = this.defaultcolor;
                    this.$set(this.bgcolors, b, this.defaultcolor);
                })
            }


        },
        handleClose() {

        },
        caculateSize() {
            if (!this.noResize) {
                this.noResize = true;
                if (this.row <= 0) this.row = 1;
                if (this.col <= 0) this.col = 1;
                let h = window.innerHeight * 0.6;
                let w = window.innerWidth * 0.95;
                //window.console.log("w=%d, h= %d", w, h);
                let cellSize = Math.round(Math.min(h / this.row, w / this.col));
                this.fontSize = Math.round(cellSize * 0.45) + "px";
                this.tableWidth = cellSize * this.col + "px";
                this.tableHeight = cellSize * this.row + "px";
                let that = this;
                setTimeout(function () {
                    that.noResize = false;
                }, 400)
            }

        },

        createRoom() {
            const nickname = this.nickname;
            const roomName = this.roomName;
            this.ws.send(JSON.stringify({ type: 'createRoom', nickname, roomName }));
        },

        joinRoom() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            const nickname = this.nickname;
            const roomName = this.roomName;
            this.ws.send(JSON.stringify({ type: 'joinRoom', nickname, roomName }));
        },

        leaveRoom() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.ws.send(JSON.stringify({ type: 'leaveRoom' }));
        },

        startGame() {
            if (this.roomInfo.roomName && this.roomInfo.roomName.length > 0) {
                this.ws.send(JSON.stringify({ type: 'startGame' }));
            } else {
                this.$message({
                    message: '请先创建或加入房间',
                    type: 'warning'
                });
            }

        },

        getRoomsInfo() {
            this.ws.send(JSON.stringify({ type: 'getRoomsInfo' }));
        },

        displayRoomsInfo(roomsInfo) {
            const roomsInfoDiv = document.getElementById('roomsInfo');
            roomsInfoDiv.innerHTML = '<h2>Rooms Info</h2>';
            roomsInfo.forEach(room => {
                const roomDiv = document.createElement('div');
                roomDiv.textContent = `Room: ${room.roomName}, Players: ${room.playerCount}`;
                roomsInfoDiv.appendChild(roomDiv);
            });
        },

        updateGameProgress(roomState) {
            this.ws.send(JSON.stringify({ type: 'gameProgress', roomState }));
        },
        handleRoomButtonClick(room) {
            if (room.playerCount < 2) {
                this.ws.send(JSON.stringify({ type: 'joinRoom', nickname: this.nickname, roomName: room.roomName }));
            } else {
                this.$message.error('房间已满');
            }
        },
        getBadgeType(playerCount) {
            if (playerCount === 0) {
                return 'primary'; // 蓝色
            } else if (playerCount === 1) {
                return 'success'; // 绿色
            } else {
                return 'danger'; // 红色
            }
        },
    },
    computed: {
        calcTip() {
            if (this.cur < this.row * this.col) return this.cur + 1;
            else return "开始";
        }
    }
}
</script>

<style scoped>
.notice {
    alignment: center;
    border: 1px solid #2c3e50;
}

.notice td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #666666;
    text-align: center;
}


.rooms-info-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 80%;
    margin: 0 auto;
}

.rooms-info-container .item {
    margin: 5px;
}

.item {
    margin-top: 10px;
    margin-right: 30px;
}
</style>